export default __webpack_public_path__ + "static/media/480_portfolio03-nl-mobile.26157616.png";